import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnSuccess
} from "@insite/client-framework/HandlerCreator";
import {
    Session,
    UpdateSessionApiParameter,
} from "@insite/client-framework/Services/SessionService";
import { getSelectedCategoryPath, getSelectedProductPath, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, LoadCart } from "@insite/client-framework/Store/Context/Handlers/UpdatePickUpWarehouse";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import displayProducts from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import loadProduct from "@WhiteCap/Handlers/LoadProduct/LoadProduct";


type UpdatePickUpWarehouseParameter = {
    pickUpWarehouse: WarehouseModel;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<UpdatePickUpWarehouseParameter, UpdateSessionApiParameter, Session>;

export const LoadProductDetails: HandlerType = props => {
    const pageType = getCurrentPage(props.getState()).type;
    const location = getLocation(props.getState());

    if (pageType === "ProductDetailsPage") {
        const queryString = location.search;
        const productPath =
            getSelectedProductPath(props.getState()) ||
            (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
        const queryParams = parseQueryString<{ option?: string; criteria?: string }>(queryString.replace("?", ""));
        const styledOption = (
            queryParams.option?.toString() ||
            queryParams.criteria?.toString() ||
            ""
        ).toLocaleLowerCase();
        props.dispatch(loadProduct({ path: productPath, styledOption }));
    }
}

export const LoadProductList: HandlerType = props => {
    const pageType = getCurrentPage(props.getState()).type;
    const location = getLocation(props.getState());

    if (pageType === "ProductListPage") {
        const selectedCategoryPath = getSelectedCategoryPath(props.getState());
        const pathnameLowerCase = location.pathname.toLowerCase();
        const path =
            selectedCategoryPath ||
            (pathnameLowerCase.startsWith("/content/") || pathnameLowerCase.startsWith("/.spire/")
                ? ""
                : location.pathname);
        const searchPath = getSettingsCollection(props.getState()).searchSettings.searchPath;
        const search = location.search;

        const isSearchPath = () => {
            return !!path.toLowerCase().startsWith(`/${searchPath.toLowerCase()}`);
        }
        props.dispatch(displayProducts({
            path,
            queryString: search,
            isSearch: isSearchPath(),
        }));
    }
};

addToChainAfter(chain, LoadCart, LoadProductDetails);
addToChainAfter(chain, LoadProductDetails, LoadProductList);
